import React from "react";
import Icon from "@mdi/react";
import {mdiMapMarkerPath} from "@mdi/js";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({Km}: {Km: number}) => {
    return (
        <div className="text-light">
            {Km > 0 && <Icon path={mdiMapMarkerPath} size={1}/>}
            {Km > 0
                ? <span className="ms-1">{Km} km</span>
                : <span> </span>
            }
        </div>
    );
}